import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined'
import { useTranslation } from 'react-i18next'

type PatientLocationDisplayProps = {
  description: string
}

export default function PatientLocationDisplay({ description }: PatientLocationDisplayProps) {
  const { t } = useTranslation()

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, p: 1.5, borderRadius: 1, bgcolor: 'action.hover' }}>
      <PlaceOutlinedIcon fontSize="small" color="primary" />
      <Box>
        <Typography variant="caption" color="text.secondary">
          {t('page.liveConsultation.patientLocation.title')}
        </Typography>
        <Typography variant="body2">{description}</Typography>
      </Box>
    </Box>
  )
}
